module.exports = __webpack_public_path__ + "static/img/deposit.7afea0c9.png";